import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fresh_txt"
}
const _hoisted_2 = { style: {"min-height":"100vh","position":"relative","width":"100%","background":"#FCF2EC"} }

import { computed,ref,onMounted } from 'vue';
import router from './router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const startLocation = ref(0);
const freshcontainer = ref();
const moveDistance = ref(0); //移动的位置
 
const isTransition = ref(false); //移动的J距离
 
const handlerstart = (e:any) => {
  startLocation.value = e.touches[0].pageY;
 
};
const handlermove = (e:any) => {
  moveDistance.value = Math.floor(e.touches[0].pageY - startLocation.value);
 
  freshcontainer.value.style.transform = `translateY(${moveDistance.value}px)`;
};
const handlerend = (e:any) => {
  if(moveDistance.value>100){location.reload()}
  moveDistance.value = 0;
  isTransition.value = true;
  freshcontainer.value.style.transform = `translateY(0px)`;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "wrap",
    ref_key: "freshcontainer",
    ref: freshcontainer,
    onTouchstart: handlerstart,
    onTouchmove: handlermove,
    onTouchend: handlerend
  }, [
    (moveDistance.value>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "释放即可刷新"))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 544))
}
}

})